<div *ngIf="this.screenWidth > 825" class="flex gap-1">
	<!-- <p-button id="buttonAddPermission" pTooltip="{{ 'ADD_PERMISSION' | translate }}"
		tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addPermission()"
		[rounded]="false" [text]="true" severity="primary">
	</p-button> -->
	<!-- <button pButton pRipple id="buttonAddPermission" pTooltip="{{ 'ADD_PERMISSION' | translate }}"
		tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addPermission()"
		class="p-button-primary bg-blue-800 hover:surface-800 text-normal hover:text-primary border-transparent mb-1"
		[rounded]="false">
	</button> -->
	<!-- <div class="flex align-items-center">
		<p-button id="buttonCustomizeEmail" [label]="'CUSTOMIZE_EMAIL' | translate" (click)="customizeEmail()"
			class="mt-2" styleClass="font-medium" [rounded]="false" [text]="true" severity="secondary"
			[disabled]="isFinalUsers()">
			<i class="text-xl pi cm-mail mr-2 mb-1"></i>
		</p-button>
	</div> -->
</div>

<div *ngIf="this.screenWidth <= 825" class="flex justify-content-end px-0">
	<button pButton pRipple icon="pi cm-ellipsis-v" class="p-button-text text-color"
		(click)="permissionsMenu.toggle($event)"></button>
	<p-menu #permissionsMenu [popup]="true" appendTo="body" [model]="permissionsMenuitems"></p-menu>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>